







import Vue from 'vue';
import { parseLanguageHelper } from '@/heplers';
import { Component, Prop } from 'vue-property-decorator';
import { TreeData } from '@/templates/Tree';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames } from '@/templates/DataNames';
import { parseHrefHelper } from '@/heplers/stringHelpers';

@Component({})
export default class NodeLink extends Vue {
  @Prop(Object) node: { kind: string; children: TreeData; title: string };
  parseHref = parseHrefHelper;

  /**
   * Переходим по ссылке только если она не текущая
   */
  goToLink(fqdn: string) {
    const link: string = this.parseHref(fqdn, '/docs/');

    GlobalBus.emit(GlobalBusNames.CLOSEMOBILEMENU);

    if (link !== this.$router.currentRoute.path) this.$router.push(link).catch((err) => err);
  }

  parseLanguage(title: string | { [lang: string]: string }): string {
    return parseLanguageHelper(title);
  }
}
